var map = {
	"./prism-coy.css": 46,
	"./prism-dark.css": 47,
	"./prism-funky.css": 48,
	"./prism-okaidia.css": 49,
	"./prism-solarizedlight.css": 50,
	"./prism-tomorrow.css": 51,
	"./prism-twilight.css": 52,
	"./prism.css": 53
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45;